import React,{useEffect} from 'react'
import { Box, Typography ,Button,Link} from '@mui/material'
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme)=>({
    link:{
        "&:visited":{
            color:'inherit'
        },
        "&:active":{
            color:'inherit'
        },
        "&:hover":{
            color:'inherit'
        }
    },container:{
        width:'75%',display:'flex',height:'600px',alignItems:'center',justifyContent:'center',flexDirection:'column',
        [theme.breakpoints.down("800")]:{
           width:"95%"
        } 
    },content:{
        maxWidth:'550px',
        [theme.breakpoints.down("800")]:{
           maxWidth:'95%'
         }
    }
}))

const GetInTouch = ({refer}) => {
    const classes = useStyles()
    useEffect(()=>{
        
    },[refer])
    return (
        <div ref={refer} style={{display:'flex',alignItems:'center',justifyContent:'center',marginTop:'50px'}}>
            <Box className={classes.container}>
                
                <Typography style={{color:'#64ffda',fontWeight:'400',fontSize:'16px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>{"03.\t\t\t What's Next?"}</Typography>
                <Typography variant="h3" style={{color:'#ccd6f6',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Get In Touch</Typography>
                <Typography className={classes.content} style={{display:'flex',justifyContent:'center',alignItems:'center',textAlignLast:'center',textAlign:'justify',color:'#8892AF',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",fontSize:"18px"}}>I’m  currently looking for  new  opportunities, my inbox is always open. Whether you have a question or just want to say hi, I’ll try my best to get back to you!</Typography>
                <Button variant='text' style={{color:"#64ffda",border:'1px solid #64ffda',padding:'5px 30px 5px 30px',fontWeight:'400',marginTop:'30px',textTransform:'none',fontSize:'18px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>
                    <Link style={{textDecoration:'none',color:"#64ffda"}} target="_blank" href={"https://mail.google.com/mail/?view=cm&fs=1&to=suprithhattikal461@gmail.com"}>
                        Say Hello
                    </Link>
                    
                </Button>
            </Box>
        </div>
    )
}

export default GetInTouch
